import {listUsers} from "@/services/api/app/dropbox/recovery/recovery";
import {defaultPagination} from "@/services/pagination";

const defaultState = () => ({
  users: [],
  pagination: {
    ...defaultPagination(),
    sortBy: 'name',
    sortDescending: false
  },
  search: null,
});

export default {
  namespaced: true,
  actions: {
    listUsers({commit, state},) {
      return listUsers({
        pagination: state.pagination,
        search: state.search,
        filter: {
          "statuses": [
            1, 2, 4
          ]
        }
      })
        .then(({result, pagination}) => {
          commit('setUsers', result)
          commit('setPagination', pagination)
          return result;
        })
    },
  },

  mutations: {
    setUsers(state, users) {
      state.users = users.map(user => {
        user.gmail = user.gMail;
        return user;
      });
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    setSearch(state, search) {
      state.search = search;
    },
    resetPagination(state, {keepSort}) {
      if (keepSort) {
        state.pagination = {
          ...defaultPagination(),
          sortBy: state.pagination.sortBy,
          sortDescending: state.pagination.sortDescending,
        }
      } else {
        state.pagination = {
          ...defaultPagination(),
          sortBy: 'fullName',
          sortDescending: false
        };
      }
    },
    resetState(state) {
      Object.assign(state, defaultState())
    }
  },

  //getter to return the first element from the users list called getDefaultUser
  getters: {
    // returns the very first user, or null if the list is empty
    getDefaultUser: (state) => {
      return state.users.length > 0 ? state.users[0] : null;
    },

    // if you also need to look up by ID:
    getUserById: (state) => (id) => {
      return state.users.find(u => u.userId === id) || null;
    },
  },

  state: defaultState,

  modules: {}
}
